import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";

class ProductBookingTimingBox extends Component {
  render() {
    const {
      time,
      key,
      onClick,
      settings,
      language,
      themeColor,
      selectedTime,
      current_product,
    } = this.props;
    return language === "english" ? (
      <div
        style={{
          alignItems: "center",
          display: (current_product.time_slots_style === 2) | 3 ? "" : "flex",
          width:
            (current_product.time_slots_style === 2) | 3 ? "fit-content" : "",
          flexDirection:
            (current_product.time_slots_style === 2) | 3 ? "" : "column",
        }}
      >
        <span
          key={key}
          value={time.id}
          onClick={onClick}
          className={`pointer${
            (selectedTime === time.id ? "active" : "",
            (current_product.time_slots_style === 2) | 3 ? "" : "mx-4")
          }`}
          style={{
            color: selectedTime === time.id && themeColor,
            border: `1px solid ${
              selectedTime === time.id ? themeColor : "#99999999"
            }`,
            borderRadius: 5,
            minWidth: "160px",
            padding: 15,
            display: "inline-block",
            marginRight: (current_product.time_slots_style === 2) | 3 ? "" : 10,
          }}
        >
          {!time.all_day
            ? `${moment(time.start, "HH:mm:ss").format("h:mm A")}${
                settings.show_booking_end_slot
                  ? `-${moment(time.end, "HH:mm:ss").format("h:mm A")}`
                  : ""
              }`
            : `All Day`}
        </span>
        {settings.show_booking_slots_inventory && (
          <span
            className="my-2"
            style={{
              fontSize: 12,
              color:
                time.inventory < 5
                  ? "red"
                  : time.inventory < 10
                  ? "orange"
                  : "green",
            }}
          >{`${time.inventory} left`}</span>
        )}
      </div>
    ) : (
      <div
        style={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <span
          key={key}
          value={time.id}
          onClick={onClick}
          className={` pointer ${
            (selectedTime === time.id ? "active" : "",
            (current_product.time_slots_style === 2) | 3 ? "" : "mx-4")
          }`}
          style={{
            color: selectedTime === time.id && themeColor,
            border: `1px solid ${
              selectedTime === time.id ? themeColor : "#99999999"
            }`,
            borderRadius: 5,
            padding: 15,
            minWidth: "160px",
            width:
              (current_product.time_slots_style === 2) | 3 ? "fit-content" : "",
            direction: "rtl",
          }}
        >
          {!time.all_day
            ? `${moment(time.start, "HH:mm:ss")
                .format("h:mm A")
                .replace("AM", "ص")
                .replace("PM", "م")}${
                settings.show_booking_end_slot
                  ? ` الى ${moment(time.end, "HH:mm:ss")
                      .format("h:mm A")
                      .replace("AM", "ص")
                      .replace("PM", "م")}`
                  : ""
              }`
            : "اليوم بالكامل"}
        </span>
        {settings.show_booking_slots_inventory && (
          <span
            className="my-2"
            style={{
              fontSize: 12,
              color:
                time.inventory < 5
                  ? "red"
                  : time.inventory < 10
                  ? "orange"
                  : "green",
            }}
          >{`${time.inventory} متبقي`}</span>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(ProductBookingTimingBox);
